module.exports = __webpack_public_path__ + "img/piano-4.c6a295a8.png";